module.exports = __webpack_public_path__ + "img/bg2.bb72478c.png";